import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  size: PropTypes.string,
};

const OperaIcon = ({ size = '32', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Opera"
    viewBox="0 0 512 512"
    width={size}
    {...props}
  >
    <rect width="512" height="512" rx="15%" fill="#fff" />
    <path
      d="M255.9 41a215 215 0 0 0 0 430 215 215 0 0 0 0-430m2.4 56.5a113.3 158.5 0 0 1 0 317 113.3 158.5 0 0 1 0-317"
      fill="#a70014"
    />
    <path
      d="M185.2 377.2a113.3 158.5 0 0 1 0-242.3c30.9-40.1 76.7-65.5 128-65.5 31.4 0 60.9 9.6 86 26.3a215 215 0 1 0 0 320.6c-25.5 17.1-55.5 26.3-86.2 26.3-51.2 0-97-25.4-127.9-65.4"
      fill="#ff1b2d"
    />
  </svg>
);

OperaIcon.propTypes = propTypes;

export default OperaIcon;
